import {
  Component, ElementRef, HostBinding, HostListener, Input, OnChanges, Renderer2
} from '@angular/core';

import { RenderSelectComponent } from 'render/render-shared/ui/render-select/render-select.component';


@Component({
  selector: 'render-select-option',
  template: `
    <ng-content></ng-content>
  `,
  styleUrls: ['render-select-option.component.scss']
})
export class RenderSelectOptionComponent implements OnChanges {

  @Input() public image!: string;
  @Input() public value!: string;
  @Input() public text!: string;
  @Input() public isDisabled: boolean = false;

  constructor(
      public el: ElementRef,
      public listbox: RenderSelectComponent,
      private readonly renderer: Renderer2
  ) {
    this.renderer.setAttribute(this.el.nativeElement, 'role', 'option');
  }

  @HostListener('keyup.enter')
  @HostListener('click')
  public onSelectLayout(): void {
    if (!this.isDisabled) {
      this.listbox.toggle();
      this.listbox.optionSelected(this.image, this.value, this.text, true);
    }
  }

  @HostBinding('class.disabled-option')
  public get isOptionDisabled(): boolean {
    return this.isDisabled;
  }

  public ngOnChanges(): void {
    this.listbox.addOption(this);
  }

}
